import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";
import {IObjectKeys} from "../../constants/interfaces";

type State = {
	data: IObjectKeys,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "notifications",
	initialState: {
		data: {},
		isLoading: false,
		error: null
	},
	reducers: {
		fetchNotificationsStart: (state: State) => {
			state.isLoading = true;
		},
		fetchNotificationsSuccess: (state: State, action) => {
			state.isLoading = false;
			if (action.payload && action.payload.data) {
				state.data[action.payload.cellId] = action.payload.data.map((item: any) => {
					return {
						brandId: item.brandId,
						relationId: item.relationId,
						title: item.title,
						content: item.content,
						subType: item.subType,
						type: item.type,
						section: item.section,
						uri: item.uri,
						timestamp: item.timestamp
					}
				});
			}
		},
		fetchNotificationsFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchNotificationsStart,
	fetchNotificationsSuccess,
	fetchNotificationsFailed
} = slice.actions;

export const getNotifications = (brands: string, interval: any, sections: string, tags: string, type: string, isPaid: string, videoFilter: string, pageType: string, includeChannels: string, excludeChannels: string, cellId: number) => async (dispatch: Function) => {
	try {
		dispatch(fetchNotificationsStart());
		const api = new Api();
		const result = await api.getNotifications(brands, interval, sections, tags, type, isPaid, videoFilter, pageType, includeChannels, excludeChannels,);
		const payload = {
			data: result,
			cellId
		}
		if (result !== "No internet connection") {
			dispatch(fetchNotificationsSuccess(payload));
		}
	} catch (err: any) {
		dispatch(fetchNotificationsFailed(err));
	}
};
